// 使用栈缓存路由，返回时再弹出最新缓存路由
// 使用localStorage将数据缓存到浏览器
const setItem = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};
const getItem = (key) => {
  const catchData = JSON.parse(localStorage.getItem(key));
  return catchData ? catchData : [];
};
export default class RouteStack {
  constructor() {
    this.stack = [];
  }

  // 将路由路径压入栈顶
  push(route) {
    this.stack = getItem("RouteStack");
    // 升级可以缓route对象
    this.stack.push(JSON.stringify(route));
    setItem("RouteStack", this.stack);
  }

  // 从栈顶弹出路由路径
  pop() {
    this.stack = getItem("RouteStack");
    // 升级获取缓存route对象
    const route = this.stack.pop();
    setItem("RouteStack", this.stack);
    return JSON.parse(route);
  }
}
